export const GC_LINE_MARGIN_TOP = {
  DEFAULT: -20,
  TABLET: 40,
  MOBILE: -20,
};
